import Pane from 'components/Common/Pane'
import { getImageUrl } from 'lib/image/imageUtils'
import React from 'react'
import styled, { keyframes } from 'styled-components'
import { animatedBackgroundIds } from 'tripPlanner/pages/trip/AITripConstants'

const Container = styled(Pane)`
  display: grid;
  grid-template: "backdrop" 1fr / 1fr;
  position: relative;
`

const FadeDuration = 7

const FrameFadeAnimation = keyframes`
    0%, 100% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  `

const BaseFrame = styled.div`
  pointer-events: none;
  animation-name: ${FrameFadeAnimation};
  animation-duration: ${FadeDuration}s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: bottom;
  opacity: 0;
  grid-area: backdrop;
`

const AnimatedBackground1 = styled(BaseFrame)`
  background-image: url(${getImageUrl(animatedBackgroundIds[0])});
  animation-delay: ${FadeDuration}s;
`
const AnimatedBackground2 = styled(BaseFrame)`
  background-image: url(${getImageUrl(animatedBackgroundIds[1])});
  animation-delay: ${(FadeDuration / 2)}s;
`
const AnimatedBackground3 = styled(BaseFrame)`
  background-image: url(${getImageUrl(animatedBackgroundIds[2])});
  animation-delay: 0s;
`

interface Props {
  className?: string
}

function GradientAnimatedBackground(props: Props) {
  const { className } = props

  return <Container className={className} paletteType="inverse">
    <AnimatedBackground1 />
    <AnimatedBackground2 />
    <AnimatedBackground3 />
  </Container>
}

export default GradientAnimatedBackground
